@if (recordsList$ | async; as fragmentsList) {
  <ng-container [formGroup]="form">
    @if (profiles$ | async; as profiles) {
      @for (profile of profiles; track profile) {
        <sh-profile-input-fieldset
          [profile]="profile"
          [formGroup]="form"
          [records]="fragmentsList"
          [recordInheritance]="recordInheritance"
          [aiProfile]="aiProfile"
          [isBatchEdit]="isBatchEdit"
        ></sh-profile-input-fieldset>
      }
      @if (profiles.length === 0) {
        <sh-notification
          [type]="notificationType.Error"
          [title]="'record-detail.notifications.no-profiles.title' | translate"
          [message]="'record-detail.notifications.no-profiles.message' | translate: { amount: fragmentsList.length }"
          [icon]="'delete'"
        ></sh-notification>
      }
    }
  </ng-container>
}
